import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'
import { FaEdit } from "react-icons/fa";
import { BsEyeFill } from "react-icons/bs";





export default function Main() {




  const [view,setview]=useState([])

  

  useEffect(() => {
    getAll();
  }, []);




  const getAll = async ()=> {
    const data = new FormData();
    
    data.append('name',"nme");


            axios({
              method: 'post',
              url: '/api/eth_blogs/all_blogs_view.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
               
                
            
                setview(s.data)
                console.log(s.data)
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };



  return (
    <>
     <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
       
       <Head />
       <div>
    

{/* 2 */}
        <div className="page-content">
        <div className="row">
          
    <div className="col-md-12 grid-margin stretch-card">
      <div className="card p-3">
      Total Blogs : {view.length}
        <div className="card-body">
          <div className="table-responsive">
            <table id="dataTableExample" className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>URL</th>
                  <th>Title</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  view.map((v)=>(
<tr>
        <td>{v.id}</td>
                  <td>{v.slug}</td>
                  <td>{v.title}</td>
                  <td>{v.status}</td>
               
                 

                  
                  <td> <a href={"contant-view?id="+v.id}> 
                    <button  className="btn btn-primary p-2 m-2"><BsEyeFill /></button>
                    </a>
                     <a href={"blog-update?id="+v.id}> 
                    <button  className="btn btn-primary p-2 m-2"><FaEdit /> Edit</button>
                    </a>
                    </td>
                  
                  </tr>
                  ))
                }
                
             
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

    </div>
     
  
       
        <Footer/>
       
      </div>
    </div>
  </>

  )
}
